/**
 * Taille et trait des icones Lucide, fixes pour toute l'application (spec
 * §8.1) : un fournisseur unique plutot qu'une prop repetee sur chaque icone.
 */
import type { ReactNode } from 'react';
import { LucideProvider } from 'lucide-react';

export const TAILLE_ICONE = 16;
export const TRAIT_ICONE = 1.75;

export function FournisseurIcones({ children }: { children: ReactNode }) {
  return (
    <LucideProvider size={TAILLE_ICONE} strokeWidth={TRAIT_ICONE}>
      {children}
    </LucideProvider>
  );
}
